import React, {memo} from 'react';

interface MaterialInputType {
    placeholder: string,
    name: string,
    required?: boolean,
    type?: string,
    value?: string,
    className?: string,
    relativeClassName?: string,
    autoComplete?: string,
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const MaterialInput = React.forwardRef(({
                                            placeholder,
                                            name,
                                            value,
                                            required = false,
                                            className = 'focus:border-black',
                                            type = 'text',
                                            relativeClassName = 'my-2',
                                            onChange,
                                            autoComplete
                                        }: MaterialInputType) => {
    const onLocalChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(e);
        }
    }

    return (
        <>
            <div className={`relative float-label-input ${relativeClassName}`}>
                <input onChange={onLocalChange} required={required} value={value} autoComplete={autoComplete ?? name}
                       type={type} id={name} placeholder=""
                       className={`w-full bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-md py-3 px-3 block appearance-none leading-normal ${className}`}/>
                <label htmlFor={name}
                       className="absolute top-3 left-0 text-gray-400 pointer-events-none transition duration-200 ease-in-outbg-white px-2 text-grey-darker">{placeholder}</label>
            </div>
        </>
    );

});
MaterialInput.displayName = 'MaterialInput';

export default memo(MaterialInput);
